import { render } from "./hykd.vue?vue&type=template&id=7c8f4c79&scoped=true&ts=true"
import script from "./hykd.vue?vue&type=script&lang=ts"
export * from "./hykd.vue?vue&type=script&lang=ts"

import "./hykd.vue?vue&type=style&index=0&id=7c8f4c79&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8f4c79"]])

export default __exports__